'use strict';

exports.__esModule = true;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _urlConfigService = require('./url.config.service.endpoints');

var _urlConfigService2 = _interopRequireDefault(_urlConfigService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var urlConfig = function () {
    function urlConfig() {
        _classCallCheck(this, urlConfig);
    }

    urlConfig.baseUrlAssembly = function baseUrlAssembly(environment) {
        var _environmentBaseUrls$ = this.environmentBaseUrls[environment],
            customerServiceBase = _environmentBaseUrls$.customerServiceBase,
            locationServiceBase = _environmentBaseUrls$.locationServiceBase,
            nutritionServiceBase = _environmentBaseUrls$.nutritionServiceBase,
            orderingServiceBase = _environmentBaseUrls$.orderingServiceBase,
            careerServices = _environmentBaseUrls$.careerServices,
            env = _environmentBaseUrls$.env,
            wwwenv = _environmentBaseUrls$.wwwenv,
            paymentURL = _environmentBaseUrls$.paymentURL,
            facebookAppId = _environmentBaseUrls$.facebookAppId;


        return {
            googleAnalytics: 'https://www.google-analytics.com/collect',

            careerServiceBase: careerServices + '/jobs/',

            geolocation: locationServiceBase + '/geocode?',
            locationsNearby: locationServiceBase + '/nearbyLocations?',
            deliveryAvailability: locationServiceBase + '/delivery/available?',
            nutritionalData: nutritionServiceBase + '/nutritionalData?',

            paymentBaseUrl: paymentURL,

            facebookAppId: facebookAppId,

            autoReload: customerServiceBase + '/autoReload',
            balanceTransfer: customerServiceBase + '/balanceTransfer',
            changePassword: customerServiceBase + '/changePassword/',
            createProfile: customerServiceBase + '/createProfile',
            customerServiceBase: customerServiceBase + '/',
            emailVerification: customerServiceBase + '/createProfile/verification',
            favoriteLocations: customerServiceBase + '/favoriteLocations/',
            favoriteItems: customerServiceBase + '/favoriteItems/',
            favoriteMeals: customerServiceBase + '/favoriteMeals/',
            login: customerServiceBase + '/login',
            logout: customerServiceBase + '/logout',
            offers: customerServiceBase + '/offers/',
            passcode: customerServiceBase + '/passcode/',
            transactionHistory: customerServiceBase + '/transactionHistory/',

            menuGetNationalMenu: orderingServiceBase + '/menu/getNationalMenu',
            menuGetNationalOrderModes: orderingServiceBase + '/menu/getNationalMenu/orderModes',
            menuGetSiteMenu: orderingServiceBase + '/menu/getSiteMenu',
            menuGetSiteOrderModes: orderingServiceBase + '/menu/getSiteMenu/orderModes',
            menuGetUpSell: orderingServiceBase + '/menu/upsell',
            menuGetCampaign: orderingServiceBase + '/menu/campaigns',
            menuGetSalesItems: orderingServiceBase + '/menu/salesItems',
            saveMenuFavorites: orderingServiceBase + '/menu/saveMenuFavorites',
            getMenuFavorites: orderingServiceBase + '/menu/getMenuFavorites',
            ordering: orderingServiceBase + '/order/',
            paymentMethod: orderingServiceBase + '/paymentMethod',

            csoCategoryImageBase: 'https://app' + env + '.wendys.com/unified/assets/menu/productGroups/',
            csoProductImageBase: 'https://app' + env + '.wendys.com/unified/assets/menu/products/',
            categoryImageBase: 'https://app' + env + '.wendys.com/unified/assets/menu/productGroups/',
            productImageBase: 'https://app' + env + '.wendys.com/unified/assets/menu/products/',
            productImageBaseProportional: 'https://app' + env + '.wendys.com/unified/assets/menu/cropped/',
            productHeroImageBaseProportional: 'https://app' + env + '.wendys.com/unified/assets/menu/croppedhero/',
            productHeroImageBase: 'https://app' + env + '.wendys.com/unified/assets/menu/hero/',
            productGroupImageBase: 'https://app' + env + '.wendys.com/unified/assets/menu/pg-cropped/',
            productGroupHeroImageBase: 'https://app' + env + '.wendys.com/unified/assets/menu/pg-croppedhero/',

            //loyalty services
            available: customerServiceBase + '/loyalty/available',
            loyaltySummaryCSO: customerServiceBase + '/loyalty/summary/CSO',
            enroll: customerServiceBase + '/loyalty/enroll',
            pendingEnroll: customerServiceBase + '/loyalty/pendingEnroll',
            preEnrollCSO: customerServiceBase + '/loyalty/preEnroll/CSO',
            rewards: customerServiceBase + '/loyalty/rewards',
            rewardCatalog: customerServiceBase + '/loyalty/rewardCatalog',
            selectReward: customerServiceBase + '/loyalty/selectReward',
            summary: customerServiceBase + '/loyalty/summary',
            replaceLoyaltyCard: customerServiceBase + '/loyalty/replaceCard',
            currentSummary: customerServiceBase + '/loyalty/current',
            updateLoyaltyCardNumber: customerServiceBase + '/loyalty/updateLoyaltyCardNumber',

            //loyalty menu services
            menuGetRewardSalesItems: orderingServiceBase + '/menu/getSiteMenu/rewardOptions',

            appWendys: {
                en_US: 'https://www' + wwwenv + '.wendys.com/en-us/wendys-app',
                es_US: 'https://www' + wwwenv + '.wendys.com/es-us/wendys-app',
                en_CA: 'https://www' + wwwenv + '.wendys.com/en-ca/wendys-app',
                fr_CA: 'https://www' + wwwenv + '.wendys.com/fr-ca/wendys-app'
            },

            iosWendys: 'https://itunes.apple.com/us/app/my-wendys/id540518599',

            androidWendys: 'https://play.google.com/store/apps/details?id=com.wendys.nutritiontool&hl=en',

            accountSetUp: 'http://my' + env + '.wendys.com/account-set-up',

            nav: {
                orderLink: 'https://order' + env + '.wendys.com',
                menuLink: 'https://menu' + env + '.wendys.com',
                findLink: 'https://find' + env + '.wendys.com',
                myLink: 'https://my' + env + '.wendys.com',
                aboutLink: 'https://www' + wwwenv + '.wendys.com/en-us/about-wendys',
                careerLink: 'http://careers' + env + '.wendys.com',
                locationsLink: 'https://locations.wendys.com',
                localized: {
                    en_US: {
                        home: 'https://www' + wwwenv + '.wendys.com/en-us/Home',
                        about_us: 'https://www' + wwwenv + '.wendys.com/en-us/about-wendys',
                        menuLinks: {
                            menu_1: 'https://www' + wwwenv + '.wendys.com/en-us/hamburgers',
                            menu_2: 'https://www' + wwwenv + '.wendys.com/en-us/chicken',
                            menu_3: 'https://www' + wwwenv + '.wendys.com/en-us/salads',
                            menu_4: 'https://www' + wwwenv + '.wendys.com/en-us/right-price-right-size',
                            menu_5: 'https://www' + wwwenv + '.wendys.com/en-us/fries-sides',
                            menu_6: 'https://www' + wwwenv + '.wendys.com/en-us/beverages',
                            menu_7: 'https://www' + wwwenv + '.wendys.com/en-us/kids-meals',
                            menu_8: 'https://www' + wwwenv + '.wendys.com/en-us/frosty',
                            menu_cta: 'https://www' + wwwenv + '.wendys.com/en-us/breakfast'
                        },
                        learnLinks: {
                            nutrition: 'https://www' + wwwenv + '.wendys.com/en-us/nutrition-info',
                            gift_card: 'http://www.amazon.com/Wendys-20-Gift-Card/dp/B00P3DUFRW/ref=sr_1_6?ie=UTF8&qid=1417455051&sr=8-6&keywords=wendy',
                            meal_builder: 'https://www' + wwwenv + '.wendys.com/en-us/meal-builder'
                        },
                        playLinks: {
                            kids_meal: 'https://www' + wwwenv + '.wendys.com/en-us/wendys-kids-meal',
                            sign_up: 'https://my' + env + '.wendys.com/#/account/showWendysMail'
                        },
                        footerLinks: {
                            contact_wendys: 'https://www' + wwwenv + '.wendys.com/en-us/contact-wendys',
                            unsubscribe: 'https://www' + wwwenv + '.wendys.com/en-us/unsubscribe',
                            check_card_balance: 'https://www' + wwwenv + '.wendys.com/en-us/check-card-balance',
                            sign_up: 'https://my' + env + '.wendys.com/account/mail',
                            wendys_app: 'https://www' + wwwenv + '.wendys.com/en-us/wendys-app',
                            privacy_policy: 'https://www' + wwwenv + '.wendys.com/en-us/privacy-policy',
                            cookie_policy: 'https://www' + wwwenv + '.wendys.com/en-us/cookie-policy',
                            site_map: 'https://www' + wwwenv + '.wendys.com/en-us/SiteMap',
                            foster_care: 'https://www' + wwwenv + '.wendys.com/en-us/foster-care',
                            responsibility: 'https://www' + wwwenv + '.wendys.com/en-us/about-wendys/responsibility-overview',
                            international: 'https://www' + wwwenv + '.wendys.com/en-us/about-wendys/global-growth-vision',
                            investors: 'https://www' + wwwenv + '.wendys.com/en-us/about-wendys/investor-dashboard',
                            payment_incident: 'https://www' + wwwenv + '.wendys.com/en-us/about-wendys/the-wendys-company-updates'
                        }
                    },
                    es_US: {
                        home: 'https://www' + wwwenv + '.wendys.com/es-us/Home',
                        about_us: 'https://www' + wwwenv + '.wendys.com/es-us/about-wendys',
                        menuLinks: {
                            menu_1: 'https://www' + wwwenv + '.wendys.com/es-us/hamburgers',
                            menu_2: 'https://www' + wwwenv + '.wendys.com/es-us/chicken',
                            menu_3: 'https://www' + wwwenv + '.wendys.com/es-us/salads',
                            menu_4: 'https://www' + wwwenv + '.wendys.com/es-us/right-price-right-size',
                            menu_5: 'https://www' + wwwenv + '.wendys.com/es-us/fries-sides',
                            menu_6: 'https://www' + wwwenv + '.wendys.com/es-us/beverages',
                            menu_7: 'https://www' + wwwenv + '.wendys.com/es-us/kids-meals',
                            menu_8: 'https://www' + wwwenv + '.wendys.com/es-us/frosty',
                            menu_cta: 'https://www' + wwwenv + '.wendys.com/es-us/breakfast'
                        },
                        learnLinks: {
                            nutrition: 'https://www' + wwwenv + '.wendys.com/es-us/nutrition-info',
                            gift_card: 'http://www.amazon.com/Wendys-20-Gift-Card/dp/B00P3DUFRW/ref=sr_1_6?ie=UTF8&qid=1417455051&sr=8-6&keywords=wendy',
                            meal_builder: 'https://www' + wwwenv + '.wendys.com/es-us/meal-builder'
                        },
                        playLinks: {
                            kids_meal: 'https://www' + wwwenv + '.wendys.com/es-us/wendys-kids-meal',
                            wendymail: 'http://my' + env + '.wendys.com/#/account/showWendysMail'
                        },
                        footerLinks: {
                            contact_wendys: 'https://www' + wwwenv + '.wendys.com/es-us/contact-wendys',
                            unsubscribe: 'https://www' + wwwenv + '.wendys.com/es-us/unsubscribe',
                            check_card_balance: 'https://www' + wwwenv + '.wendys.com/es-us/check-card-balance',
                            sign_up: 'https://my' + env + '.wendys.com/account/mail',
                            wendys_app: 'https://www' + wwwenv + '.wendys.com/es-us/wendys-app',
                            privacy_policy: 'https://www' + wwwenv + '.wendys.com/es-us/privacy-policy',
                            cookie_policy: 'https://www' + wwwenv + '.wendys.com/es-us/cookie-policy',
                            site_map: 'https://www' + wwwenv + '.wendys.com/es-us/SiteMap',
                            foster_care: 'https://www' + wwwenv + '.wendys.com/es-us/foster-care',
                            responsibility: 'https://www' + wwwenv + '.wendys.com/es-us/about-wendys/responsibility-overview',
                            international: 'https://www' + wwwenv + '.wendys.com/es-us/about-wendys/global-growth-vision',
                            investors: 'https://www' + wwwenv + '.wendys.com/es-us/about-wendys/investor-dashboard',
                            payment_incident: 'https://www' + wwwenv + '.wendys.com/es-us/about-wendys/the-wendys-company-updates'
                        }
                    },
                    fr_CA: {
                        home: 'https://www' + wwwenv + '.wendys.com/fr-ca/Home',
                        about_us: 'https://www' + wwwenv + '.wendys.com/fr-ca/about-wendys',
                        menuLinks: {
                            menu_1: 'https://www' + wwwenv + '.wendys.com/fr-ca/hamburgers',
                            menu_2: 'https://www' + wwwenv + '.wendys.com/fr-ca/chicken',
                            menu_3: 'https://www' + wwwenv + '.wendys.com/fr-ca/salads',
                            menu_4: 'https://www' + wwwenv + '.wendys.com/fr-ca/right-price-right-size',
                            menu_5: 'https://www' + wwwenv + '.wendys.com/fr-ca/fries-sides',
                            menu_6: 'https://www' + wwwenv + '.wendys.com/fr-ca/beverages',
                            menu_7: 'https://www' + wwwenv + '.wendys.com/fr-ca/kids-meals',
                            menu_8: 'https://www' + wwwenv + '.wendys.com/fr-ca/frosty',
                            menu_cta: 'https://www' + wwwenv + '.wendys.com/fr-ca/pair-2'
                        },
                        learnLinks: {
                            meal_builder: 'https://www' + wwwenv + '.wendys.com/fr-ca/meal-builder',
                            quality: 'https://www' + wwwenv + '.wendys.com/fr-ca/quality-story'
                        },
                        playLinks: {
                            kids_meal: 'https://www' + wwwenv + '.wendys.com/fr-ca/Home#'
                        },
                        footerLinks: {
                            contact_wendys: 'https://www' + wwwenv + '.wendys.com/fr-ca/contact-wendys',
                            unsubscribe: 'https://www' + wwwenv + '.wendys.com/fr-ca/unsubscribe',
                            check_card_balance: 'https://www' + wwwenv + '.wendys.com/fr-ca/check-card-balance',
                            sign_up: 'https://my' + env + '.wendys.com/account/mail',
                            wendys_app: 'https://www' + wwwenv + '.wendys.com/fr-ca/wendys-app',
                            privacy_policy: 'https://www' + wwwenv + '.wendys.com/fr-ca/privacy-policy',
                            cookie_policy: 'https://www' + wwwenv + '.wendys.com/fr-ca/cookie-policy',
                            site_map: 'https://www' + wwwenv + '.wendys.com/fr-ca/SiteMap',
                            foster_care: 'https://www' + wwwenv + '.wendys.com/fr-ca/foster-care',
                            responsibility: 'https://www' + wwwenv + '.wendys.com/fr-ca/about-wendys/responsibility-overview',
                            international: 'https://www' + wwwenv + '.wendys.com/fr-ca/about-wendys/global-growth-vision',
                            investors: 'https://www' + wwwenv + '.wendys.com/fr-ca/about-wendys/investor-dashboard',
                            payment_incident: 'https://www' + wwwenv + '.wendys.com/fr-ca/about-wendys/the-wendys-company-updates'
                        }
                    },
                    en_CA: {
                        home: 'https://www' + wwwenv + '.wendys.com/en-ca/Home',
                        about_us: 'https://www' + wwwenv + '.wendys.com/en-ca/about-wendys',
                        menuLinks: {
                            menu_1: 'https://www' + wwwenv + '.wendys.com/en-ca/hamburgers',
                            menu_2: 'https://www' + wwwenv + '.wendys.com/en-ca/chicken',
                            menu_3: 'https://www' + wwwenv + '.wendys.com/en-ca/salads',
                            menu_4: 'https://www' + wwwenv + '.wendys.com/en-ca/right-price-right-size',
                            menu_5: 'https://www' + wwwenv + '.wendys.com/en-ca/fries-sides',
                            menu_6: 'https://www' + wwwenv + '.wendys.com/en-ca/beverages',
                            menu_7: 'https://www' + wwwenv + '.wendys.com/en-ca/kids-meals',
                            menu_8: 'https://www' + wwwenv + '.wendys.com/en-ca/frosty',
                            menu_cta: 'https://www' + wwwenv + '.wendys.com/en-ca/pair-2'
                        },
                        learnLinks: {
                            meal_builder: 'https://www' + wwwenv + '.wendys.com/en-ca/meal-builder',
                            quality: 'https://www' + wwwenv + '.wendys.com/en-ca/quality-story'
                        },
                        playLinks: {
                            kids_meal: 'https://www' + wwwenv + '.wendys.com/en-ca/Home#',
                            satisfy: 'https://www.youtube.com/watch?v=rmbl2kqs0eA'
                        },
                        footerLinks: {
                            contact_wendys: 'https://www' + wwwenv + '.wendys.com/en-ca/contact-wendys',
                            unsubscribe: 'https://www' + wwwenv + '.wendys.com/en-ca/unsubscribe',
                            check_card_balance: 'https://www' + wwwenv + '.wendys.com/en-ca/check-card-balance',
                            sign_up: 'https://my' + env + '.wendys.com/account/mail',
                            wendys_app: 'https://www' + wwwenv + '.wendys.com/en-ca/wendys-app',
                            privacy_policy: 'https://www' + wwwenv + '.wendys.com/en-ca/privacy-policy',
                            cookie_policy: 'https://www' + wwwenv + '.wendys.com/en-ca/cookie-policy',
                            site_map: 'https://www' + wwwenv + '.wendys.com/en-ca/SiteMap',
                            foster_care: 'https://www' + wwwenv + '.wendys.com/en-ca/foster-care',
                            responsibility: 'https://www' + wwwenv + '.wendys.com/en-ca/about-wendys/responsibility-overview',
                            international: 'https://www' + wwwenv + '.wendys.com/en-ca/about-wendys/global-growth-vision',
                            investors: 'https://www' + wwwenv + '.wendys.com/en-ca/about-wendys/investor-dashboard',
                            payment_incident: 'https://www' + wwwenv + '.wendys.com/en-ca/about-wendys/the-wendys-company-updates'
                        }
                    }
                }
            },

            images: {
                csoComponents: 'https://app' + env + '.wendys.com/unified/assets/menu/components/',
                csoProducts: 'https://app' + env + '.wendys.com/unified/assets/menu/products/',
                components: 'http://app' + env + '.wendys.com/unified/assets/menu/components/',
                disclaimers: 'http://app' + env + '.wendys.com/unified/assets/menu/disclaimers/',
                products: 'http://app' + env + '.wendys.com/unified/assets/menu/products/',
                offers: 'http://app' + env + '.wendys.com/unified/assets/offers/',
                featuredItems: 'https://app' + env + '.wendys.com/unified/assets/featuredItems/',
                campaignItemsWeb: 'https://app' + env + '.wendys.com/unified/assets/campaign/order.wendys/',
                campaignItemsCSO: 'https://app' + env + '.wendys.com/unified/assets/campaign/cso/',
                transaction_summary_icon: 'https://app' + env + '.wendys.com/mywendys/', //todo implement new url when available
                modifier_group_icons: 'https://app' + env + '.wendys.com/unified/assets/menu/modifierGroups/', //todo implement when images available on svn
                upSell: 'https://app' + env + '.wendys.com/unified/assets/upsell/'
            },

            terms: {
                en_US: 'https://www' + wwwenv + '.wendys.com/en-us/terms-conditions',
                en_CA: 'https://www' + wwwenv + '.wendys.com/en-ca/terms-conditions',
                fr_CA: 'https://www' + wwwenv + '.wendys.com/fr-ca/terms-conditions',
                es_US: 'https://www' + wwwenv + '.wendys.com/es-us/terms-conditions'
            },

            privacy: {
                en_US: 'https://www' + wwwenv + '.wendys.com/en-us/privacy-policy',
                en_CA: 'https://www' + wwwenv + '.wendys.com/en-ca/privacy-policy',
                fr_CA: 'https://www' + wwwenv + '.wendys.com/fr-ca/privacy-policy',
                es_US: 'https://www' + wwwenv + '.wendys.com/es-us/privacy-policy'
            },

            rewardsTerms: {
                en_US: 'https://www' + wwwenv + '.wendys.com/en-us/rewards-terms-conditions',
                en_CA: 'https://www' + wwwenv + '.wendys.com/en-ca/rewards-terms-conditions',
                fr_CA: 'https://www' + wwwenv + '.wendys.com/fr-ca/rewards-terms-conditions',
                es_US: 'https://www' + wwwenv + '.wendys.com/es-us/rewards-terms-conditions'
            }
        };
    };

    urlConfig.getConfig = function getConfig(environment, URLOverride) {
        var _this = this;

        if (URLOverride) {
            var overrideList = this.endpointsToOverrideURLFor.join(',');
            Object.keys(this.environmentBaseUrls[environment]).forEach(function (key) {
                if (overrideList.indexOf(key) !== -1) {
                    _this.environmentBaseUrls[environment][key] = URLOverride;
                }
            });
        }

        var baseUrls = this.baseUrlAssembly(environment);
        var loyaltyConfig = this.loyaltyConfig;
        return {
            urls: _lodash2.default.merge({}, baseUrls, _urlConfigService2.default.get(baseUrls)),
            loyaltyConfig: loyaltyConfig
        };
    };

    return urlConfig;
}();

urlConfig.endpointsToOverrideURLFor = ['customerServiceBase', 'locationServiceBase', 'orderingServiceBase', 'nutritionServiceBase', 'careerServices'];
urlConfig.customerRestService = "CustomerServices/rest";
urlConfig.locationRestService = "LocationServices/rest";
urlConfig.nutritionRestService = "NutritionServices/rest";
urlConfig.orderingRestService = "OrderingServices/rest";
urlConfig.careersRestService = "WendysJobService";
urlConfig.environmentBaseUrls = {

    LOCAL: {
        customerServiceBase: 'https://services-dev.wendys.com/' + urlConfig.customerRestService,
        locationServiceBase: 'https://locationservices-dev.wendys.com/' + urlConfig.locationRestService,
        nutritionServiceBase: 'https://nutritionservices-dev.wendys.com/' + urlConfig.nutritionRestService,
        orderingServiceBase: 'https://orderingservices-dev.wendys.com/' + urlConfig.orderingRestService,
        careerServices: 'https://careers-dev-services.wendys.com/' + urlConfig.careersRestService,
        env: '-dev',
        wwwenv: '-dev',
        paymentURL: 'https://payment-dev.wendys.com/',
        facebookAppId: '1610954445832903'
    },
    DEV: {
        customerServiceBase: 'https://services-dev.wendys.com/' + urlConfig.customerRestService,
        locationServiceBase: 'https://locationservices-dev.wendys.com/' + urlConfig.locationRestService,
        nutritionServiceBase: 'https://nutritionservices-dev.wendys.com/' + urlConfig.nutritionRestService,
        orderingServiceBase: 'https://orderingservices-dev.wendys.com/' + urlConfig.orderingRestService,
        careerServices: 'https://careers-dev-services.wendys.com/' + urlConfig.careersRestService,
        env: '-dev',
        wwwenv: '-dev',
        paymentURL: 'https://payment-dev.wendys.com/',
        facebookAppId: '1610954445832903'
    },
    DEV_SERVER: {
        customerServiceBase: 'http://localhost:4000/' + urlConfig.customerRestService,
        locationServiceBase: 'http://localhost:4000/' + urlConfig.locationRestService,
        nutritionServiceBase: 'http://localhost:4000/' + urlConfig.nutritionRestService,
        orderingServiceBase: 'http://localhost:4000/' + urlConfig.orderingRestService,
        careerServices: 'http://localhost:4000/' + urlConfig.careersRestService,
        env: '-dev',
        wwwenv: '-dev',
        paymentURL: 'https://payment-dev.wendys.com/',
        facebookAppId: '1610954445832903'
    },
    TEST: {
        customerServiceBase: 'https://services-test.wendys.com/' + urlConfig.customerRestService,
        locationServiceBase: 'https://locationservices-test.wendys.com/' + urlConfig.locationRestService,
        nutritionServiceBase: 'https://nutritionservices-test.wendys.com/' + urlConfig.nutritionRestService,
        orderingServiceBase: 'https://orderingservices-test.wendys.com/' + urlConfig.orderingRestService,
        careerServices: 'https://careers-test-services.wendys.com/' + urlConfig.careersRestService,
        env: '-test',
        wwwenv: '-test',
        paymentURL: 'https://payment-test.wendys.com/',
        facebookAppId: '1610954445832903'
    },
    PQA: {
        customerServiceBase: 'https://services-pqa.wendys.com/' + urlConfig.customerRestService,
        locationServiceBase: 'https://locationservices-pqa.wendys.com/' + urlConfig.locationRestService,
        nutritionServiceBase: 'https://nutritionservices-pqa.wendys.com/' + urlConfig.nutritionRestService,
        orderingServiceBase: 'https://orderingservices-pqa.wendys.com/' + urlConfig.orderingRestService,
        careerServices: 'https://careers-pqa-services.wendys.com/' + urlConfig.careersRestService,
        env: '-pqa',
        wwwenv: '-pqa1',
        paymentURL: 'https://s3.amazonaws.com/wendys-pqa-cloudfront-payment/',
        facebookAppId: '1610954445832903'
    },
    PROD: {
        customerServiceBase: 'https://services.wendys.com/' + urlConfig.customerRestService,
        locationServiceBase: 'https://locationservices.wendys.com/' + urlConfig.locationRestService,
        nutritionServiceBase: 'https://nutritionservices.wendys.com/' + urlConfig.nutritionRestService,
        orderingServiceBase: 'https://orderservice.wendys.com/' + urlConfig.orderingRestService,
        careerServices: 'https://careers-services.wendys.com/' + urlConfig.careersRestService,
        env: '',
        wwwenv: '',
        paymentURL: 'https://payment.wendys.com/',
        facebookAppId: '1610949225833425'
    }
};
urlConfig.loyaltyConfig = {
    enableLoyaltyCard: false
};
exports.default = urlConfig;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/config/url.config.js
// module id = 604
// module chunks = 0